import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  FormGroup,
} from "reactstrap";
import { postSaveProfiles } from "../requests/req-system";
import { form_validate, notifica } from "../requests/utils";
const model_dto = {
  idPerfil: null,
  descripcion: null,
  idEstatus: false,
  idUsuarioAct: null,
};

const model_required = {
  descripcion: {
    message: "Ingrese la descripción del perfil",
  },
};

const ModalPerfil = (props) => {
  const { className, visible, onClosed, onSucces, data } = props;
  const [values, setValues] = useState({ ...model_dto });

  useEffect(() => {
    if (data.idPerfil) {
      const newValues = { ...values };
      Object.keys(values).forEach((item) => {
        newValues[item] = data[item] ? data[item] : null;
      });
      setValues(newValues);
    }
  }, [props]);

  const toggle = () => {
    onClosed();
  };
  const setFieldValues = (field, value) => {
    const newValues = { ...values };
    newValues[field] = value;
    setValues(newValues);
  };

  const onSubmit = async () => {
    let valid_ = form_validate(values, model_required);
    if (valid_.valid) {
      let res_api = await postSaveProfiles(values);
      if (res_api) {
        if (res_api.code === 0) {
          notifica(
            "success",
            "Los cambios se guardaron correctamente",
            "!Alerta"
          );
          onSucces();
          toggle();
        } else {
          notifica("error", res_api.message, "Error");
        }
      }
    } else {
      notifica("error", valid_.message, "Error");
    }
  };

  return (
    <div>
      <Modal isOpen={visible} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>
          {data.idPerfil
            ? `Edición del perfil ${data.descripcion}`
            : "Alta de perfiles"}
        </ModalHeader>
        <ModalBody>
          <FormGroup row>
            <Col sm={6} md={6} lg={12}>
              <label>Descripción:</label> <br></br>
              <input
                type="text"
                className="inp_large"
                value={values.descripcion}
                onChange={(e) => setFieldValues("descripcion", e.target.value)}
                placeholder="Ingrese la descripción del perfil"
              />
            </Col>
            {data.idPerfil ? (
              <Col sm={6} md={6} lg={12}>
                <label>{values.idEstatus ? "Desactivar" : "Activar"}:</label>{" "}
                <br></br>
                <div className="ckF_disable">
                  <input
                    type="checkbox"
                    id={`check_`}
                    checked={values.idEstatus}
                    onClick={(e) => {
                      setFieldValues("idEstatus", !values.idEstatus);
                    }}
                  />
                  <label htmlFor={`check_`}>
                    <span></span>
                  </label>
                </div>
              </Col>
            ) : null}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => onSubmit()}>
            GUARDAR
          </Button>
          <Button color="secondary" onClick={() => toggle()}>
            CANCELAR
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalPerfil;
